import { TaskVisualStatus } from './types'

export const TASK_STATUS_ORDER = {
  [TaskVisualStatus.COMPLETED_INSTANT]: 1,
  [TaskVisualStatus.COMPLETED_CREDENTIALS]: 1,
  [TaskVisualStatus.COMPLETED_DOCUMENTS]: 1,
  [TaskVisualStatus.COMPLETED_IRS]: 2,
  [TaskVisualStatus.COMPLETED_BANK]: 3,
  [TaskVisualStatus.IN_PROGRESS]: 10,
  [TaskVisualStatus.ERROR]: 50,
  [TaskVisualStatus.SKIPPED]: 50,
  [TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS]: 100,
  [TaskVisualStatus.NOT_ATTEMPTED_DOCUMENTS]: 100,
  [TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS_DOCUMENTS]: 100,
  [TaskVisualStatus.NOT_ATTEMPTED_IRS]: 101,
  [TaskVisualStatus.NOT_ATTEMPTED_BANK]: 102,
}
